<template>
  <ScRender :fields="fields">
    <nav :class="['secondary-nav', {editable: isEditMode}, { dark: isDarkTheme }]">
      <div class="intersect"></div>
      <ImageCarousel controlsPositionY="center" :activeItem="activeItemIndex" :theme="themeColor">
        <NavigationItem v-for="(item, index) in fields.links" :key="index" :isActive="item.isActive">
          <nuxt-link class="nav-link" :to="item.link">
            {{ item.name }}
          </nuxt-link>
        </NavigationItem>
      </ImageCarousel>
    </nav>
  </ScRender>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ImageCarousel, NavigationItem } from '@sohohouse/design-system'
import ScRender from '../sc-render'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')
const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'SecondaryNavigation',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      headingHeight: 0
    }
  },

  components: {
    ImageCarousel,
    NavigationItem,
    ScRender
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['themeColor', 'isDarkTheme']),

    activeItemIndex () {
      // set active item a little bit right, do not move on first 3
      const index = this.fields.links.findIndex(item => item.isActive) - 1
      return index >= 1 ? index : 0
    }
  }
}
</script>

<style lang="scss" >
.secondary-nav {
  position: sticky;
  top: 0;
  z-index: 2;
  background: $color-white;
  margin: 0 0 $space-020;
  &.dark {
    background-color: $color-black;
  }

  @include tablet() {
    margin: 0 0 $space-070;
    padding-right: $space-060;
  }

  li > .nav-link {
    @include font('060');
    margin: $space-050 $space-050 $space-050 0;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;

    @include tablet() {
      margin-right: $space-040;
    }
  }

  > div {
    margin-bottom: 0;
  }
}

.editable {
  position: static;
}
</style>
